/* MAISON: country determines the initial language; explicit choices remain independent.
 * Shopify Country/region redirection ON, Language redirection OFF.
 * No external requests. Romania is excluded. */
(() => {
  'use strict';
  const node = document.getElementById('maison-language-config');
  if (!node) return;
  const c = JSON.parse(node.textContent);
  if (c.designMode || window.__maisonLanguageStarted) return;
  window.__maisonLanguageStarted = true;
  const RULES = {DE: 'de', AT: 'de', CH: 'de', FR: 'fr'};
  const FALLBACK = 'en';
  const COOKIE = 'maison_language_choice';
  const DAYS = 180;
  const languages = c.languages || [];
  const available = code => languages.some(l => l.code === code);
  const readCookie = name => {
    const part = document.cookie.split('; ').find(v => v.startsWith(name + '='));
    return part ? decodeURIComponent(part.slice(name.length + 1)) : '';
  };
  const writeCookie = (name, value, days) => {
    document.cookie = name + '=' + encodeURIComponent(value) + '; Path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '') +
      (days ? '; Max-Age=' + days * 86400 : '');
    return readCookie(name) === value;
  };
  const sessionGet = key => {
    try { return sessionStorage.getItem(key) || readCookie(key); } catch (_) { return readCookie(key); }
  };
  const sessionSet = (key, value) => {
    try { sessionStorage.setItem(key, value); if (sessionStorage.getItem(key) === value) return true; } catch (_) {}
    return writeCookie(key, value);
  };
  const notice = document.getElementById('maison-language-notice');
  const dismissKey = 'maison_language_dismissed';
  const remember = code => {
    if (available(code)) writeCookie(COOKIE, code, DAYS);
    sessionSet(dismissKey, '1');
    notice.hidden = true;
  };
  // Capture Focal's existing desktop, mobile and footer choices before submission.
  document.addEventListener('click', e => {
    const b = e.target.closest('button[name="locale_code"],button[name="language_code"]');
    if (b && b.form && b.form.querySelector('[name="form_type"][value="localization"]')) remember(b.value);
  }, true);
  document.addEventListener('change', e => {
    if (e.target.matches('select[name="locale_code"],select[name="language_code"]')) remember(e.target.value);
  }, true);
  // No automatic action or notice in Romania, even if a foreign preference is saved.
  if (c.country === 'RO') return;
  const desired = available(RULES[c.country]) ? RULES[c.country] : (available(FALLBACK) ? FALLBACK : c.current);
  const saved = readCookie(COOKIE);
  const explicit = c.root && c.root !== '/' &&
    (location.pathname === c.root.replace(/\/$/, '') || location.pathname.startsWith(c.root.replace(/\/$/, '') + '/'));
  const pendingKey = 'maison_language_pending';
  const guardKey = 'maison_language_attempt_' + c.country;
  const pending = sessionGet(pendingKey);
  const change = (code, manual) => {
    if (!available(code)) return false;
    if (manual) remember(code);
    if (code === c.current) return false;
    const form = document.getElementById('maison-language-form');
    if (!form) return false;
    form.querySelector('[name="language_code"]').value = code;
    let ret = form.querySelector('[name="return_to"]');
    if (!ret) { ret = document.createElement('input'); ret.type = 'hidden'; ret.name = 'return_to'; form.appendChild(ret); }
    ret.value = location.pathname + location.search + location.hash;
    // Only language is submitted: Shopify retains the active country and cart.
    form.submit();
    return true;
  };
  // Explicit language URLs win over an old preference. Root URLs use the saved choice.
  if (!explicit && !(available(saved) && saved === c.current)) {
    const target = available(saved) ? saved : desired;
    if (target !== c.current && !sessionGet(guardKey)) {
      // Persist a loop guard BEFORE submitting. If storage is blocked, do not auto-redirect.
      if (sessionSet(guardKey, '1')) {
        if (!available(saved)) sessionSet(pendingKey, c.country + ':' + target);
        if (change(target, false)) return;
      }
    }
  }
  if (available(saved) || sessionGet(dismissKey)) return;
  if (explicit && pending !== c.country + ':' + c.current) return;
  const codes = [desired, 'en'];
  for (const raw of (navigator.languages || [navigator.language || ''])) {
    const match = languages.find(l => l.code.toLowerCase() === raw.toLowerCase()) ||
      languages.find(l => l.code.toLowerCase() === raw.toLowerCase().split('-')[0]);
    if (match) { codes.push(match.code); break; }
  }
  const unique = [...new Set(codes.filter(available))];
  if (unique.length < 2) return;
  const options = document.getElementById('maison-language-options');
  unique.forEach(code => {
    const b = document.createElement('button');
    b.type = 'button'; b.lang = code;
    b.textContent = languages.find(l => l.code === code).name;
    b.setAttribute('aria-pressed', String(code === c.current));
    b.addEventListener('click', () => change(code, true)); options.appendChild(b);
  });
  document.getElementById('maison-language-close').addEventListener('click', () => {
    sessionSet(dismissKey, '1'); notice.hidden = true;
  });
  sessionSet(dismissKey, '1');
  notice.hidden = false;
})();
